/* ============================================================
   Moodi — Gift Progress Bar
   Companion to sections/moodi-gift-bar.liquid

   Loaded with `defer`. Safe to include twice on one page (e.g.
   a header-group instance plus a template instance) — the
   window.MoodiGiftBar guard makes the second execution a no-op
   refresh rather than a second set of network patches.
   ============================================================ */
(function () {
  if (window.MoodiGiftBar) { window.MoodiGiftBar.refresh(); return; }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function delim(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }
    var match = format.match(placeholder);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delim(cents, 0); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = delim(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delim(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      default: value = delim(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  // Dots sit at the CENTRE of each equal column ((i + 0.5) / n), matching the
  // Liquid render. Fill advances dot-to-dot in proportion to the cart total,
  // then completes to 100% once the final tier is cleared.
  // NOTE: this formula is duplicated in the section's Liquid — change both.
  function computeFill(total, tiers) {
    var n = tiers.length; if (!n) return 0;
    var prevT = 0, prevPos = 0;
    for (var i = 0; i < n; i++) {
      var t = tiers[i].threshold;
      var pos = ((i + 0.5) / n) * 100;
      if (total < t) {
        var frac = (t - prevT) ? (total - prevT) / (t - prevT) : 0;
        return prevPos + frac * (pos - prevPos);
      }
      prevT = t; prevPos = pos;
    }
    return 100;
  }

  // Pin the headline wrapper to its real rendered height (px) so the condensed
  // state can transition it to 0 smoothly. scrollHeight reads the full content
  // height even while the wrapper is collapsed.
  function measureCollapse(el) {
    var c = el.querySelector('[data-mcb-collapse]');
    if (c) c.style.height = c.scrollHeight + 'px';
  }

  function updateBar(el, cart) {
    var total = cart.total_price;
    var count = cart.item_count;

    // The bar is persistent: visible on every page it's placed on, empty cart
    // included, so customers see the gift ladder before adding item one. This
    // clear() guards against a stale class surviving a section re-render.
    el.classList.remove('mcb--hidden');
    // Empty cart bolds the whole headline — see .mcb--empty in the CSS.
    el.classList.toggle('mcb--empty', count <= 0);

    var labels = el.querySelectorAll('[data-mcb-label]');
    var dots = el.querySelectorAll('[data-mcb-dot]');
    var tiers = [];
    labels.forEach(function (l) {
      tiers.push({
        threshold: parseInt(l.getAttribute('data-threshold'), 10) || 0,
        reward: l.getAttribute('data-reward') || ''
      });
    });

    var fill = el.querySelector('[data-mcb-fill]');
    if (fill) {
      // Empty cart = zero fill, no token sliver. Above zero, a 2% floor keeps
      // small carts visible. Mirrors the Liquid render.
      var pct = total <= 0 ? 0 : Math.min(Math.max(computeFill(total, tiers), 2), 100);
      fill.style.width = pct + '%';
    }

    labels.forEach(function (l, i) { l.classList.toggle('is-unlocked', total >= tiers[i].threshold); });
    dots.forEach(function (d, i) { d.classList.toggle('is-unlocked', total >= tiers[i].threshold); });

    var next = null;
    for (var i = 0; i < tiers.length; i++) { if (total < tiers[i].threshold) { next = tiers[i]; break; } }

    var fmt = el.getAttribute('data-money-format') || '${{amount}}';
    var msg = el.querySelector('[data-mcb-message]');
    if (msg) {
      if (next) {
        // Empty cart gets its own phrasing — "spend $110 more" is wrong when
        // you haven't spent anything yet.
        var tpl = count <= 0
          ? (el.getAttribute('data-message-empty') || el.getAttribute('data-message-progress') || '')
          : (el.getAttribute('data-message-progress') || '');
        msg.innerHTML = tpl
          .replace('[amount]', '<strong>' + formatMoney(next.threshold - total, fmt) + '</strong>')
          .replace('[reward]', '<strong>' + next.reward + '</strong>');
      } else {
        msg.innerHTML = el.getAttribute('data-message-complete') || '';
      }
    }
    measureCollapse(el);
  }

  // Shopify wraps each section in a .shopify-section div exactly the bar's
  // height, so `position: sticky` on the bar itself has no room to work. Make
  // the wrapper sticky instead, sitting just below the theme's sticky header
  // (height measured live). While stuck, add .mcb--condensed so the headline
  // collapses and only the bar itself stays pinned.
  function setupSticky(el) {
    if (el.__mcbStickyInit || !el.classList.contains('mcb--sticky')) return;
    el.__mcbStickyInit = true;
    var sec = el.closest('.shopify-section') || el;
    var extra = parseInt(el.getAttribute('data-sticky-extra'), 10) || 0;
    sec.style.position = 'sticky';
    // Theme content blocks (e.g. collection hero text) use z-index up to 3, and
    // the header sits at 4 — there's no free slot between them. Bump the header
    // to 5 and slot the bar at 4: above all page content, below the nav and its
    // dropdown menus.
    var headerSec = document.querySelector('.section-header');
    if (headerSec) {
      var hz = parseInt(getComputedStyle(headerSec).zIndex, 10);
      if (!isNaN(hz) && hz <= 4) headerSec.style.zIndex = '5';
    }
    sec.style.zIndex = '4';
    // The section sits inside a colour-scheme div with its own solid background
    // (e.g. .color-scheme-1). Clear every wrapper up to the section so the
    // transparent desktop wings actually show the page beneath.
    var node = el.parentElement;
    while (node) {
      node.style.setProperty('background', 'transparent', 'important');
      if (node === sec) break;
      node = node.parentElement;
    }
    var topPx = 0;
    function setTop() {
      var header = document.querySelector('.section-header');
      var h = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
      topPx = h + extra;
      sec.style.top = topPx + 'px';
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var stuck = window.scrollY > 24 && sec.getBoundingClientRect().top <= topPx + 1;
        el.classList.toggle('mcb--condensed', stuck);
      });
    }
    setTop();
    measureCollapse(el);
    window.addEventListener('resize', function () { setTop(); measureCollapse(el); });
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-moodi-cart-bar]').forEach(function (el) {
          setupSticky(el);
          updateBar(el, cart);
        });
      })
      .catch(function () {});
  }

  var endpoints = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  function isMutation(url) {
    if (!url) return false;
    url = String(url);
    return endpoints.some(function (e) { return url.indexOf(e) !== -1; });
  }

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var p = origFetch.apply(this, args);
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
      if (isMutation(url)) p.then(function () { setTimeout(refresh, 60); });
      return p;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) { this.__mcbUrl = url; return origOpen.apply(this, arguments); };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (isMutation(this.__mcbUrl)) this.addEventListener('load', function () { setTimeout(refresh, 60); });
    return origSend.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refresh, 60); });
  });

  // Theme Editor lifecycle: re-render when the merchant loads/edits the section
  // or selects a tier block.
  ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach(function (ev) {
    document.addEventListener(ev, function () { refresh(); });
  });

  window.MoodiGiftBar = { refresh: refresh, formatMoney: formatMoney };
  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();
